import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      setLoading(true);
      window.location.href = `/search?q=${encodeURIComponent(searchQuery.trim())}`;
    }
  };

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20classical%20law%20library%20interior%20with%20tall%20wooden%20bookshelves%20filled%20with%20leather%20bound%20legal%20books%2C%20warm%20golden%20ambient%20lighting%20from%20vintage%20desk%20lamps%2C%20marble%20columns%2C%20professional%20editorial%20photography%20style%2C%20soft%20natural%20light%2C%20warm%20brown%20and%20gold%20tones%2C%20shallow%20depth%20of%20field%2C%20sophisticated%20legal%20atmosphere%2C%20high%20detail%20architectural%20interior&width=1600&height=700&seq=hero-pravo-001&orientation=landscape"
          alt="Юридическая библиотека"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-24 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 mb-5 rounded-full bg-white/10 border border-white/20 text-white/85 text-xs md:text-sm">
          <i className="ri-shield-check-line text-accent-400" />
          Официальные первоисточники · обновляется ежедневно
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6 max-w-4xl mx-auto">
          Законы и судебная практика России
        </h1>
        <p className="text-white/85 text-base md:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Актуальные законы, кодексы и решения судов — с историей редакций и быстрым
          поиском. Точный первоисточник для юристов, адвокатов и бизнеса.
        </p>

        {/* Search bar */}
        <form
          onSubmit={handleSearch}
          className="max-w-2xl mx-auto flex flex-col sm:flex-row gap-2 sm:gap-0 bg-white/10 backdrop-blur-md rounded-full p-1.5 sm:p-2 border border-white/20"
        >
          <div className="flex-1 flex items-center gap-2 px-3 sm:px-4">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
              <i className="ri-search-line text-white/70" />
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Найдите закон, статью или судебное решение…"
              className="w-full bg-transparent text-white placeholder:text-white/50 text-sm md:text-base outline-none py-2"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2.5 bg-accent-500 hover:bg-accent-600 disabled:opacity-80 text-white font-medium text-sm rounded-full transition-colors whitespace-nowrap flex items-center justify-center gap-1.5 min-w-[110px]"
          >
            {loading ? (
              <>
                <i className="ri-loader-4-line text-sm animate-spin" />
                Ищем…
              </>
            ) : (
              <>
                <i className="ri-search-line text-sm" />
                Поиск
              </>
            )}
          </button>
        </form>

        {/* Быстрые ссылки */}
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="text-white/60 text-sm">Быстро:</span>
          <a href="/#catalog" className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white/90 text-sm transition-colors">Кодексы</a>
          <a href="/courts/district" className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white/90 text-sm transition-colors">Судебная практика</a>
          <a href="/search?q=%D1%81%D1%80%D0%BE%D0%BA%20%D0%B4%D0%B0%D0%B2%D0%BD%D0%BE%D1%81%D1%82%D0%B8" className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 text-white/90 text-sm transition-colors">Поиск по вопросу</a>
        </div>

        {/* Масштаб базы */}
        <p className="mt-6 text-white/55 text-xs md:text-sm">
          2,7 млн статей · 16,8 млн судебных решений · период 1964–2026
        </p>
      </div>
    </section>
  );
}